import script from "./Packinginformation.vue?vue&type=script&setup=true&lang=js"
export * from "./Packinginformation.vue?vue&type=script&setup=true&lang=js"

import "./Packinginformation.vue?vue&type=style&index=0&id=4b449ede&lang=scss"
import "./Packinginformation.vue?vue&type=style&index=1&id=4b449ede&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b449ede"]])

export default __exports__